import React from 'react';

// Styles & Assets
import styles from './EditButtonUser.module.css';
import { RiPencilFill } from 'react-icons/ri';

// Hooks
import { useState } from 'react';

// Components
import Modal from '../../UI/Modal/Modal';
import EditUserDialog from '../EditUserDialog/EditUserDialog';
import { UserData } from '../../../interfaces/UserInfo';

const EditButtonUser: React.FC<{
    user: UserData,
    updateUser: (user:UserData) => void,
}> = ({ user, updateUser }) => {

    const [showEditUserDialog, setShowEditUserDialog] = useState<boolean>(false);

    const handleClickEdit = () => {
        setShowEditUserDialog(true);
    };

    return (
        <>
            <div className='centerContainer'>
                <button onClick={handleClickEdit} className={styles.pencilButton}>
                    <RiPencilFill />
                </button>
            </div>
            <Modal show={showEditUserDialog} setShowModal={setShowEditUserDialog}>
                <EditUserDialog
                    user={user}
                    updateUser={updateUser}
                    setShowEditUserDialog={setShowEditUserDialog}
                />
            </Modal>
        </>
    );
};

export default EditButtonUser;